import React, { useState } from "react";
import SEO from "../components/SEO";
import { withRef } from "../components/referral";

export default function Contact() {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const fd = new FormData(form);

    const body = {
      name: fd.get("name"),
      email: fd.get("email"),
      message: withRef(fd.get("message")),
    };

    try {
      setLoading(true);
      const res = await fetch("https://api.bossdrop.ai/send-general-inquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (res.ok) {
        setStatus("✅ Thanks! We’ll get back to you shortly.");
        form.reset();
      } else {
        setStatus("⚠️ Error sending message. Please try again later.");
      }
    } catch (err) {
      console.error(err);
      setStatus("⚠️ Error sending message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="page container">
      <SEO
        title="BossDrop | Contact"
        description="Contact the BossDrop team for support, partnerships, or press. We’ll respond quickly with answers and resources."
        canonical="https://bossdrop.ai/contact"
        url="https://bossdrop.ai/contact"
        /* image="https://bossdrop.ai/og/pricing-1200x630.jpg" */
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "BossDrop",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          url: "https://bossdrop.ai/",
          publisher: {
            "@type": "Organization",
            name: "BossDrop",
            url: "https://bossdrop.ai/",
          },
        }}
        breadcrumbsJsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://bossdrop.ai/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Pricing",
              item: "https://bossdrop.ai/contact",
            },
          ],
        }}
      />
      {/* Hero */}
      <section className="hero">
        <h1 className="h1 reveal" data-reveal>
          Contact
        </h1>
        <p className="sub reveal" data-reveal style={{ "--d": "80ms" }}>
          Reach us directly by email, or send a quick note below.
        </p>
      </section>

      {/* Quick contacts */}
      <section className="grid cards">
        <article className="card reveal" data-reveal>
          <h3>General</h3>
          <p className="muted">Questions, feedback, press.</p>
          <p style={{ marginTop: 10 }}>
            <a
              href="mailto:info@bossdrop.ai"
              style={{ textDecoration: "underline" }}
            >
              info@bossdrop.ai
            </a>
          </p>
        </article>

        <article className="card reveal" data-reveal style={{ "--d": "80ms" }}>
          <h3>Sales</h3>
          <p className="muted">Tiers, pricing, and rollouts.</p>
          <p style={{ marginTop: 10 }}>
            <a
              href="mailto:sales@bossdrop.ai"
              style={{ textDecoration: "underline" }}
            >
              sales@bossdrop.ai
            </a>
          </p>
          <a
            className="btn btnPrimary"
            href="/contact-sales"
            style={{ marginTop: 10 }}
          >
            Contact Sales
          </a>
        </article>

        <article className="card reveal" data-reveal style={{ "--d": "160ms" }}>
          <h3>Support</h3>
          <p className="muted">We’re here 24/7 for customers.</p>
          <p style={{ marginTop: 10 }}>
            <a
              href="mailto:support@bossdrop.ai"
              style={{ textDecoration: "underline" }}
            >
              support@bossdrop.ai
            </a>
          </p>
        </article>
      </section>

      {/* General inquiry form (posts to backend) */}
      <section className="panel reveal" data-reveal>
        <h2 className="h2" style={{ marginTop: 0 }}>
          Send a quick note
        </h2>

        <form className="formGrid" onSubmit={handleSubmit}>
          <input
            type="hidden"
            name="_subject"
            value="General Inquiry - BossDrop"
          />

          <div className="field">
            <label>Your name</label>
            <input name="name" required placeholder="Jane Doe" />
          </div>

          <div className="field">
            <label>Your email</label>
            <input
              type="email"
              name="email"
              required
              placeholder="you@company.com"
            />
          </div>

          <div className="field wide">
            <label>Message</label>
            <textarea
              name="message"
              rows="5"
              placeholder="How can we help?"
              required
            />
          </div>

          <div className="ctaRow">
            <button className="btn btnPrimary" type="submit" disabled={loading}>
              {loading ? "Sending…" : "Send"}
            </button>
            <a className="btn btnGhost" href="mailto:info@bossdrop.ai">
              Email instead
            </a>
          </div>

          {/* Disclaimer (under buttons, matching Book Demo style) */}
          <div className="field wide">
            <p className="muted" style={{ fontSize: "12px", lineHeight: 1.4 }}>
              By entering your email, you agree to receive product updates and
              marketing emails from BossDrop. You can unsubscribe at any time.
              We respect your privacy.
            </p>
          </div>
        </form>

        {status && <p className="formStatus">{status}</p>}
      </section>
    </main>
  );
}
